export default "__VITE_ASSET__Dhr_n17c__"